import { MdsItemDropdown } from "@/design-system/constants/items/types";
import { MdsDropdownContentList, MdsDropdownIconButton } from "@/design-system/components/dropdown";
import { Uuid } from "@/domains/global/identifiers";
import { FC } from "react";

export interface MdsItemListRowActionProps {
  itemId: Uuid;
  dropdown?: MdsItemDropdown;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListRowDropdown: FC<MdsItemListRowActionProps> = ({ dropdown }) => {
  if (!dropdown) {
    return null;
  }

  const contentList: MdsDropdownContentList = {
    items: dropdown.items,
  };

  return <MdsDropdownIconButton contentList={contentList} placement="below-right-alignment" />;
};
